import { render, staticRenderFns } from "./ApplyAlter.vue?vue&type=template&id=8320caf4&"
import script from "./ApplyAlter.vue?vue&type=script&lang=js&"
export * from "./ApplyAlter.vue?vue&type=script&lang=js&"
import style0 from "./ApplyAlter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports